import {
	IBackdoorPayload,
	ICheckTermsResponse,
	ICheckUserNameResponse,
	IUserLoginPayload,
	IUserResponse,
} from "modules/types";
import {createAction} from "redux-act";
import {RequestState, ContextualProjects} from "modules/enums";

export const saveLoginPayloadStore = createAction<IUserLoginPayload>();
export const userLogin = createAction<IUserLoginPayload>("User Login");

export const retrieveUserSuccess = createAction<IUserResponse>();
export const checkUserName = createAction<Pick<IUserLoginPayload, "uid">>();
export const getSessionUser = createAction();

export const setSessionState = createAction<RequestState>();

export const checkTerms = createAction<Pick<IUserLoginPayload, "uid">>();
export const checkTermsSuccess = createAction<ICheckTermsResponse>();

export const checkUserNameSuccess = createAction<ICheckUserNameResponse>();
export const checkUserNameFailed = createAction();

export const loginBackdoorRequest = createAction<IBackdoorPayload>();
export const loginBackdoorSuccess = createAction();

export const sendWhatsNewModalViewed = createAction();
export const sendTutorialModalViewed = createAction();

export const sendThanksForPlayingViewed = createAction();
export const sendThanksForPlayingViewedSuccess = createAction();
export const actionEnableGodMode = createAction();

export interface ISuccessPrompt {
	prompt: IPrompt | null;
}

export interface IPrompt {
	game: ContextualProjects;
	message: IMessage;
}

export interface IMessage {
	en: string;
	es: string;
}

export const fetchContextualPrompt = createAction();
export const fetchContextualPromptSuccess = createAction<IPrompt | null>();
export const fetchContextualPromptError = createAction();

export const declineContextualPrompt = createAction<{uid: string; game: ContextualProjects}>();
export const declineContextualPromptSuccess = createAction<{
	uid: string;
	game: ContextualProjects;
}>();
export const declineContextualPromptError = createAction();

export const openContextualPrompt = createAction();
export const closeContextualPrompt = createAction();
